module.exports = __webpack_public_path__ + "media/images/vet-bcb4a668.png";